import { alpha, makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      height: 32,
      color: theme.palette.text.primary,
      borderRadius: theme.shape.borderRadius,
      '&:disabled': {
        '& $label': {
          color: alpha('#000', 0.28),
        },
      },
      '&$focused': {
        backgroundColor: COLORS.primary.silver,
        color: COLORS.primary.default,
      },
    },
    focused: {},
    label: {
      maxWidth: 200,
    },
    chevronIcon: {
      fontSize: theme.typography.pxToRem(16),
    },
    menuPaper: {
      width: 135,
      marginTop: theme.spacing(0.5),
      padding: theme.spacing(1),
      border: theme.shape.borderGray70,
      maxHeight: 320,
      '&$wider': {
        width: 204,
      },
    },
    wider: {},
    menuItem: {
      minHeight: 40,
      paddingLeft: theme.spacing(0),
      paddingRight: theme.spacing(0),
      marginRight: 0,
      '& label': {
        width: '100%',
        marginRight: 0,
      },
    },
    checkbox: {
      '& svg': {
        fontSize: theme.typography.pxToRem(16),
      },
      '&:hover': {
        backgroundColor: 'unset !important',
      },
    },
    optionLabel: {
      maxWidth: 320,
    },
  }),
  { name: 'FilterResourceByType' }
);
